import { Paper, Box, TableContainer, Table, TableBody, Typography } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandTable from '../../../../../../components/layout/Switch/ExpandTable';
import EmptyMessage from '../../../../../../components/Alerts/EmptyMessage';
import Syllabus, { SuggestedSyllabus } from '../../../../../../models/Syllabus';
import StudentRecordsRow from './StudentRecordsRow';
import '../../../../SuggestedSyllabusTable/SuggestedSyllabusTable.css';

interface StudentRecordsTableTableProps {
  optionsSyllabus: Syllabus[],
  onChange: (event: Syllabus | null) => void,
  itemSelected: Syllabus | null,
  loading?: boolean,
}

const StudentRecordsTable: React.FC<StudentRecordsTableTableProps> = ({ optionsSyllabus, onChange, itemSelected,  loading }) => {
  const [expandTable, setExpandTable] = useState(false);
  const { t } = useTranslation();

  const isRowSelected = (row: SuggestedSyllabus | Syllabus): boolean => {
    return itemSelected?.id === row.id;
  };

  const selectRow = (e: ChangeEvent<HTMLInputElement>, row: Syllabus) => {
    if (e.target.checked) {
      onChange(row);
    } else {
      onChange(null);
    }
  };

  return (
    <div>
      <Typography 
      variant="body1" 
      color="initial" 
      style={{ marginTop: '5px' }}>
        {t('titleStudentRecordsTable')}
      </Typography>

      <Paper variant="outlined" style={{marginBottom: '20px'}}>
      <TableContainer
        sx={{ maxHeight: expandTable ? "220px" : "200px",}}
        >
          <Table stickyHeader className="REQXXI-Request-Table" size="small" aria-label="customized table">
            <TableBody className="REQXXI-Request-TableBody" style={{ overflow: 'auto' }}>
              {!loading && optionsSyllabus?.map((row, i) => (
                <StudentRecordsRow
                  key={row ? row.id : i}
                  row={row}
                  isRowSelected={isRowSelected}
                  selectRow={selectRow}
                />
              ))}
            </TableBody>
          </Table>
          {!loading && optionsSyllabus && optionsSyllabus?.length < 1 &&
            <Box sx={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              <EmptyMessage />
            </Box>}
          {loading &&
          <Box sx={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
            <Typography variant="body1" color="initial">{t('loadingCompatibleSyllabuses')}</Typography>
          </Box>}
        </TableContainer >
      </Paper>

      {optionsSyllabus && optionsSyllabus?.length > 6 &&
        <ExpandTable onToggle={setExpandTable} active={expandTable} />
      }
    </div>
  );
};

export default StudentRecordsTable;
